// Standalone device control route (/device/:uniqueNumber). Reads the device from
// nav state (when opened from a list tile) or fetches it by UniqueNumber, then
// delegates to the shared DeviceControls router. Rendered full-screen (not
// embedded), so each control component's DeviceShell shows its own AppBar + back.

import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import DeviceControls from './DeviceControls';

export default function DeviceScreen() {
  const { uniqueNumber } = useParams();
  const { state } = useLocation();
  return (
    <DeviceControls device={state?.device} uniqueNumber={uniqueNumber} />
  );
}
